(function () {
  function getStickyRoot(element) {
    return element && element.closest && element.closest('.product-sticky-form--oc');
  }

  function getForm(root) {
    return root ? document.getElementById(root.getAttribute('form')) : null;
  }

  function getSelectedOption(root) {
    var select = root && root.querySelector('[data-oc-sticky-variant-select]');
    return select ? select.selectedOptions[0] : null;
  }

  function optionValue(option, index) {
    return option && index ? option.getAttribute('data-option-' + index) : '';
  }

  function setButtonText(button, text) {
    var target = button && (button.querySelector('.btn-text > span') || button.querySelector('.btn-text'));
    if (target) target.textContent = text;
  }

  function getOptionValues(option) {
    if (!option) return [];
    return [option.dataset.option1, option.dataset.option2, option.dataset.option3].filter(function (value) {
      return value && value !== 'Default Title';
    });
  }

  function dispatchNativeChange(element) {
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function currentColorValue(root) {
    var select = root && root.querySelector('[data-oc-sticky-variant-select]');
    var selected = getSelectedOption(root);
    var colorIndex = Number(root && root.getAttribute('data-color-option-index')) || 0;
    if (!select || !selected || !colorIndex) return '';
    return optionValue(selected, colorIndex);
  }

  function filterStickySizes(root, colorValue) {
    var select = root && root.querySelector('[data-oc-sticky-variant-select]');
    var colorIndex = Number(root && root.getAttribute('data-color-option-index')) || 0;
    if (!select || !colorIndex || !colorValue) return;

    var firstVisible = null;
    Array.prototype.forEach.call(select.options, function (option) {
      var matchesColor = optionValue(option, colorIndex) === colorValue;
      option.hidden = !matchesColor;
      option.disabled = !matchesColor;
      if (matchesColor && !firstVisible) firstVisible = option;
    });

    if (select.selectedOptions[0] && select.selectedOptions[0].hidden && firstVisible) {
      select.value = firstVisible.value;
    }
  }

  function syncNativeVariantPicker(root, selectedOption) {
    var formId = root && root.getAttribute('form');
    if (!formId || !selectedOption || !window.CSS || !CSS.escape) return;

    getOptionValues(selectedOption).forEach(function (value) {
      var escapedForm = CSS.escape(formId);
      var escapedValue = CSS.escape(value);
      var input = document.querySelector('input[form="' + escapedForm + '"][value="' + escapedValue + '"]');
      if (input && !input.closest('.product-sticky-form--oc')) {
        input.checked = true;
        dispatchNativeChange(input);
        return;
      }

      var select = Array.prototype.find.call(document.querySelectorAll('select[form="' + escapedForm + '"]'), function (candidate) {
        return !candidate.closest('.product-sticky-form--oc') && Array.prototype.some.call(candidate.options, function (option) {
          return option.value === value;
        });
      });

      if (select) {
        select.value = value;
        dispatchNativeChange(select);
      }
    });
  }

  function updateStickyUi(root) {
    if (!root) return;

    var selected = getSelectedOption(root);
    var price = selected ? selected.getAttribute('data-price') : root.getAttribute('data-current-price');
    var comparePrice = selected ? selected.getAttribute('data-compare-price') : '';
    var discount = selected ? selected.getAttribute('data-discount') : '';
    var available = selected ? selected.getAttribute('data-available') === 'true' : true;
    var isPreorder = root.getAttribute('data-is-preorder') === 'true';
    var addText = isPreorder ? root.getAttribute('data-pre-order-text') : root.getAttribute('data-add-text');
    var soldOutText = root.getAttribute('data-sold-out-text') || 'Sold out';

    var priceEl = root.querySelector('.oc-sticky-cart__current-price');
    var compareEl = root.querySelector('.oc-sticky-cart__compare-price');
    var discountEl = root.querySelector('.oc-sticky-cart__discount');
    if (priceEl && price) priceEl.textContent = price;
    if (compareEl) {
      compareEl.textContent = comparePrice || '';
      compareEl.hidden = !comparePrice;
    }
    if (discountEl) {
      discountEl.textContent = discount || '';
      discountEl.hidden = !discount;
    }

    var buttons = Array.prototype.slice.call(root.querySelectorAll('.oc-sticky-cart__button'));
    buttons.forEach(function (button) {
      button.disabled = !available;
      button.toggleAttribute('disabled', !available);
      button.toggleAttribute('aria-disabled', !available);
    });

    setButtonText(root.querySelector('.oc-sticky-cart__button--cart'), available ? addText : soldOutText);

    var dynamicCheckout = root.querySelector('[data-oc-sticky-dynamic-checkout]');
    if (dynamicCheckout) dynamicCheckout.hidden = !available;
  }

  function syncFormVariant(root, variantId) {
    var form = getForm(root);
    if (!form || !variantId) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    idInput.disabled = false;
    idInput.value = variantId;
    dispatchNativeChange(idInput);

    var stickyPaymentInput = root.querySelector('[data-oc-sticky-payment-variant-id]');
    if (stickyPaymentInput) {
      stickyPaymentInput.disabled = false;
      stickyPaymentInput.value = variantId;
      dispatchNativeChange(stickyPaymentInput);
    }
  }

  function applyStickyVariant(root, selected) {
    if (!root || !selected) return;
    syncNativeVariantPicker(root, selected);
    syncFormVariant(root, selected.value);
    updateStickyUi(root);
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-oc-sticky-variant-select]');
    if (!select) return;

    var root = getStickyRoot(select);
    applyStickyVariant(root, select.selectedOptions[0]);
  });

  function initStickyCart() {
    document.querySelectorAll('.product-sticky-form--oc').forEach(function (root) {
      filterStickySizes(root, currentColorValue(root));
      updateStickyUi(root);
    });
  }

  document.addEventListener('DOMContentLoaded', initStickyCart);
  document.addEventListener('shopify:section:load', initStickyCart);

  document.addEventListener('variant:change', function (event) {
    if (!event.detail || !event.detail.variant) return;
    var root = document.querySelector('.product-sticky-form--oc');
    var select = root && root.querySelector('[data-oc-sticky-variant-select]');
    if (!root || !select) return;

    var colorIndex = Number(root.getAttribute('data-color-option-index')) || 0;
    var variant = event.detail.variant;
    var colorValue = colorIndex ? variant['option' + colorIndex] : '';
    filterStickySizes(root, colorValue);
    select.value = String(variant.id);
    if (select.selectedOptions[0] && select.selectedOptions[0].hidden) {
      var firstVisible = Array.prototype.find.call(select.options, function (option) { return !option.hidden; });
      if (firstVisible) {
        select.value = firstVisible.value;
        syncFormVariant(root, firstVisible.value);
      }
    }
    updateStickyUi(root);
  });
})();
